export default [{
  path: '/monitoramento-360',
  component: {
    name: 'portaldocumentoBase',
    template: '<router-view />',
    meta: {
      resource: 'monitoramento_360',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'monitoramento-360-view',
    component: () => import('@/app/monitoramento-360/Monitoramento360View.vue'),
    meta: {
      resource: 'monitoramento_360',
      action: 'read',
      navActiveLink: 'monitoramento-360-view',
      pageTitle: 'Monitoramento 360',
      breadcrumb: [
        {
          text: 'Monitoramento 360',
          to: { name: 'monitoramento-360-view' },
          active: true,
        },
      ],
    },
  }],
},
]
